/**
 * Spécificités élève — les chips « Est-ce que X a des spécificités que nous
 * devrions connaître ? », partagées par les funnels d'acquisition.
 *
 * Elles vivent ici et non dans un funnel parce qu'elles sont posées à
 * l'identique par plusieurs parcours (stage, inscription) : la version stage
 * était déjà la deuxième après celle du brevet, une troisième copie aurait
 * garanti la dérive. Le vocabulaire est fermé et s'aligne sur les besoins
 * durables stockables côté serveur (StudentProfile::SPECIAL_NEEDS) — `autre` et
 * `aucun` n'y sont pas des slugs stockables, ils ne servent qu'à l'écran.
 *
 * Pas de champ texte libre : décision MVP reprise telle quelle du stage.
 */
export const FUNNEL_BESOINS = [
    { id: "dys", label: "Dys" },
    { id: "tdah", label: "TDAH" },
    { id: "hpi", label: "HPI" },
    { id: "autre", label: "Autre" },
    { id: "aucun", label: "Aucun" },
]

/** Toggle d'un besoin dans une sélection : « aucun » est exclusif des autres. */
export const toggleBesoinInList = (list, id) => {
    const current = list || []
    if (id === "aucun") {
        return current.includes("aucun") ? [] : ["aucun"]
    }
    return current.includes(id)
        ? current.filter((b) => b !== id)
        : [...current.filter((b) => b !== "aucun"), id]
}
